/** @jsx jsx */
import React from 'react';
import FormContents from 'components/atoms/Form/FormContents';
// import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import FlexBox from 'components/atoms/FlexBox';
import { css, jsx } from '@emotion/core';
import BlockUI from 'components/molecules/BlockUi';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import CalendarForm from 'components/molecules/CalendarForm';
import useAttendCSVOutputForm from './hooks';
import FormLabel from 'components/atoms/Form/FormLabel';
import FormPadding from 'components/atoms/Form/FormPadding';
import FormField from 'components/atoms/Form/FormField';
import SelectForm from 'components/molecules/SelectForm';
import FormSubmitArea from "components/atoms/Form/FormSubmitArea";
import { PrimaryButton } from "components/atoms/Button";
import FormHeader from 'components/templates/FormHeader';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

const styles = {
  betweenDays: css({
    width: '50px',
    textAlign: 'center',
  }),
};

const AttendCSVOutputForm: React.FC = () => {

  const {
    isLoading,
    orgTreesOptions,
    staffOptions,
    formik,
    employmentOptions,
    layoutIdOptions
  } = useAttendCSVOutputForm();

  return (
    <BlockUI blocking={isLoading}>
      <FormHeader title="CSV出力"/>
      <FormContents customStyle={css({marginTop:'60px'})}>
        <FormPadding >
          <FlexBox customStyle={css({padding:'8px 0'})}>
            <FlexBoxItem width="195px">
              <FormLabel
                label="期間"
              />
            </FlexBoxItem>
            <FlexBoxItem>
              <FlexBox>
                <CalendarMonth 
                  date={formik.values.targetDateFrom}
                  setDate={(date: Date) => {
                    formik.setFieldValue('targetDateFrom', date || new Date());
                  }}
                />
                <span style={{margin: '10px'}}>～</span>
                <CalendarMonth 
                  date={formik.values.targetDateTo}
                  setDate={(date: Date) => {
                    formik.setFieldValue('targetDateTo', date || new Date());
                  }}
                />
              </FlexBox>
              {/* <CalendarRangeV2 
                startDate={formik.values.targetDateFrom}
                onChangeStart={(date: Date) => {
                  formik.setFieldValue('targetDateFrom', date || new Date());
                }}
                endDate={formik.values.targetDateTo}
                onChangeEnd={(date) => {
                  if(date){
                    formik.setFieldValue('targetDateTo', date || new Date());
                  }
                }}
              /> */}
            </FlexBoxItem>
            {/* <FlexBoxItem basis="120px">
              <CalendarForm label="" date={formik.values.targetDateFrom} dateFormat='YYYY年MM月'
                changeDate={(date: Date) => {
                  formik.setFieldValue('targetDateFrom', date || new Date());
                }}/>
            </FlexBoxItem>
            <div css={styles.betweenDays}>
              ～
            </div>
            <FlexBoxItem basis="132px">
              <CalendarForm label="" date={formik.values.targetDateTo} dateFormat='YYYY年MM月'
                changeDate={(date: Date) => {
                  formik.setFieldValue('targetDateTo', date || new Date());
                }} />
            </FlexBoxItem> */}
          </FlexBox>
          <FormField displayBlock={true}>
            <FlexBox>
              {/* <FlexBoxItem basis="195px">
                <FormLabel
                  label="組織名"
                />
              </FlexBoxItem> */}
              <FlexBoxItem width="710px">
                <SelectForm
                  label="組織"
                  widthLabel="230px"
                  name="orgCode"
                  value={formik.values.orgCode || ""}
                  setValue={(v) => {
                    formik.setFieldValue('orgCode', v);
                  }}
                  options={orgTreesOptions.map((item) => ({
                    value: item.value,
                    label: item.label
                  }))}
                  placeholder=""
                  ghost={sessionStorage.getItem('loginUser.site') !== '3'}
                />
              </FlexBoxItem>
            </FlexBox>
          </FormField>
         
         
          <FormField displayBlock={true}>
            <FlexBox>
              <FlexBoxItem width="710px">
                <SelectForm
                  label="雇用形態"
                  widthLabel="230px"
                  name="employmentId"
                  value={formik.values.employmentId || ""}
                  setValue={(v) => {
                    // sessionStorage.setItem('setEmploymentId', v);
                    // setEmploymentId(v);
                    formik.setFieldValue('employmentId', v);
                  }}
                  placeholder="雇用形態を選択してください。"
                  options={employmentOptions}
                />
              </FlexBoxItem>
            </FlexBox>
          </FormField>
          <FormField displayBlock={true}>
            <FlexBox>
              <FlexBoxItem width="710px">
                <SelectForm
                  label="スタッフ"
                  widthLabel="230px"
                  name="staffCode"
                  value={formik.values.staffCode || ''}
                  setValue={(v) => {
                    formik.setFieldValue('staffCode', v);
                  }}
                  placeholder="スタッフを選択してください"
                  options={staffOptions}
                />
              </FlexBoxItem>
            </FlexBox>
          </FormField>
          <FormField displayBlock={true}>
            <FlexBox>
              <FlexBoxItem width="710px">
                <SelectForm
                  label="出力レイアウトセレクト"
                  widthLabel="230px"
                  name="layoutId"
                  value={formik.values.layoutId || ''}
                  setValue={(v) => {
                    formik.setFieldValue('layoutId', v);
                  }}
                  placeholder="スタッフを選択してください"
                  options={layoutIdOptions}
                />
              </FlexBoxItem>
            </FlexBox>
          </FormField>
          <FormSubmitArea
            customStyle={css({ textAlign: "center", paddingTop:'16px', paddingBottom:'16px' })}
          >
            <PrimaryButton
              text={"出力"}
              onClick={formik.handleSubmit}
            />
          </FormSubmitArea>
        </FormPadding>
      </FormContents> 
    </BlockUI>
  );
};

export default AttendCSVOutputForm;